module.exports = __webpack_public_path__ + "static/media/eh.cde7743d.svg";